export enum NotificationStyles {
  ALERT = "alert",
  WARNING = "warning",
  SUCCESS = "success",
  INFO = "info",
}
